"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriggerButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _IconHelp = require("../../components/Icon/icons/IconHelp");
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
/** @class TriggerButtonMixin */
/** @method */
var TriggerButtonMixin = (0, _styledToken.default)({
  borderRadius: 'TriggerButton.borderRadius',
  boxShadow: 'TriggerButton.boxShadow',
  size: 'TriggerButton.size',
  helpCircleFill: 'TriggerButton.helpCircleFillColor',
  helpCircleFillActive: 'TriggerButton.helpCircleFillColorActive',
  helpCircleFillHover: 'TriggerButton.helpCircleFillColorHover',
  helpCircleStroke: 'TriggerButton.helpCircleStrokeColor',
  helpCircleStrokeHover: 'TriggerButton.helpCircleStrokeColorHover',
  helpCircleStrokeActive: 'TriggerButton.helpCircleStrokeColorActive',
  helpQuestionFill: 'TriggerButton.helpQuestionFillColor',
  helpQuestionFillActive: 'TriggerButton.helpQuestionFillColorActive'
}, function (_ref) {
  var borderRadius = _ref.borderRadius,
    boxShadow = _ref.boxShadow,
    size = _ref.size,
    helpCircleFill = _ref.helpCircleFill,
    helpCircleFillActive = _ref.helpCircleFillActive,
    helpCircleFillHover = _ref.helpCircleFillHover,
    helpCircleStroke = _ref.helpCircleStroke,
    helpCircleStrokeHover = _ref.helpCircleStrokeHover,
    helpCircleStrokeActive = _ref.helpCircleStrokeActive,
    helpQuestionFill = _ref.helpQuestionFill,
    helpQuestionFillActive = _ref.helpQuestionFillActive;
  return (0, _styledComponents.css)(["background:transparent;display:inline-block;vertical-align:top;border:0;padding:0;border-radius:", ";height:", "px;width:", "px;", "{fill:", ";stroke:", ";}", "{fill:", ";}", ";&:active{", "{stroke:", ";fill:", ";}", "{fill:", ";}}&:focus{outline:none;box-shadow:", ";}position:relative;&:after{content:'';cursor:pointer;position:absolute;top:-5px;right:-5px;bottom:-5px;left:-5px;}"], borderRadius, size, size, _IconHelp.StyledHelpCircle, helpCircleFill, helpCircleStroke, _IconHelp.StyledHelpQuestion, helpQuestionFill, (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("\n            " + _IconHelp.StyledHelpCircle + " {\n                stroke: " + helpCircleStrokeHover + ";\n                fill: " + helpCircleFillHover + ";\n            }\n        "), _IconHelp.StyledHelpCircle, helpCircleStrokeActive, helpCircleFillActive, _IconHelp.StyledHelpQuestion, helpQuestionFillActive, boxShadow);
});
exports.TriggerButtonMixin = TriggerButtonMixin;